require("./services/Json2Csv.service");

(function() {
  "use strict";

  angular.module("UsersApp.Helpers", ["UsersApp.Helpers.Json2Csv"]);

})();
